<template>
  <section class="px-0 py-3 br-top">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="fas fa-shopping-basket"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">Livraison gratuite</h5>
              <!-- <span class="text-muted">càd 0$ comme frais de livraison</span> -->
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="far fa-credit-card"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">Paiement à la livraison</h5>
              <!-- <span class="text-muted">Up to 6 months installments</span> -->
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="fas fa-shield-alt"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">Retour sous 24h</h5>
              <!-- <span class="text-muted">Shop with fully confidence</span> -->
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="fas fa-headphones-alt"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">Support technique 24/24</h5>
              <!-- <span class="text-muted">Get friendly support</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
